import React from 'react';

interface HelpdeskIconProps {
  size?: number;
  className?: string;
  onClick?: () => void;
}

export function HelpdeskIcon({ size = 24, className = '', onClick }: HelpdeskIconProps) {
  return (
    <div 
      className={`relative ${className} cursor-pointer flex items-center justify-center`} 
      style={{ width: size, height: size }}
      onClick={onClick}
    >
      <style jsx>{`
        @keyframes headsetPulse {
          0% { transform: scale(1); }
          10% { transform: scale(1.3); }
          20% { transform: scale(1); }
          100% { transform: scale(1); }
        }
        
        .headset-component {
          animation: headsetPulse 30s infinite ease-in-out;
          transform-origin: center;
        }
      `}</style>
      
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="relative z-10 hover:scale-110 transition-all duration-300 drop-shadow-sm"
      >
        {/* Head */}
        <circle
          cx="12"
          cy="8"
          r="3"
          fill="currentColor"
          className="opacity-90"
        />
        
        {/* Body */}
        <path
          d="M12 14c-3 0-5 1.5-5 3v1h10v-1c0-1.5-2-3-5-3z"
          fill="currentColor"
          className="opacity-90"
        />
        
        {/* Left Headphone - with pulse animation */}
        <circle
          cx="7"
          cy="8"
          r="2"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          className="headset-component"
        />
        
        {/* Right Headphone - with pulse animation */}
        <circle
          cx="17"
          cy="8"
          r="2"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          className="headset-component"
        />
        
        {/* Headphone Band - with pulse animation */}
        <path
          d="M7 6c0-2.5 2.5-5 5-5s5 2.5 5 5"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          className="headset-component"
        />
      </svg>
      
      {/* Enhanced floating help indicator with increased distance */}
      <div className="absolute -top-3 -right-3 w-3 h-3 bg-gradient-to-r from-green-400 to-emerald-500 rounded-full shadow-lg animate-bounce">
        <div className="absolute inset-0 bg-green-400 rounded-full animate-ping opacity-75"></div>
        <div className="relative w-full h-full bg-gradient-to-r from-green-400 to-emerald-500 rounded-full"></div>
      </div>
    </div>
  );
}